import WelcomeTeamCreate from '@/screens/WelcomeTeamCreate';

export default function PrivateWelcomeTeamCreateRoute() {
  return <WelcomeTeamCreate />;
}
